// extracted by mini-css-extract-plugin
export default {"headerTip":"HeaderTip_headerTip__4zsQg","note":"HeaderTip_note__kbgpH"};